import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import dayjs from "@gtmhub/dayjs";

const DEFAULT_CADENCE_DURATION_IN_DAYS = 7;

export interface ICadenceChangeParams {
  cadenceStartDate: string;
  cadenceEndDate: string;
}

@Component({
  selector: "cadence-pager",
  templateUrl: "./cadence-pager.component.html",
  styleUrls: ["./cadence-pager.component.less"],
})
export class CadencePagerComponent implements OnInit {
  @Input() public cadenceDurationInDays: number = DEFAULT_CADENCE_DURATION_IN_DAYS;
  @Input() public cadenceStartDate: string = dayjs.utc().toISOString();
  @Input() public earliestAvailableDate = "";
  @Input() public latestAvailableDate = "";

  @Output() public onCadenceChange = new EventEmitter<ICadenceChangeParams>();

  public cadenceEndDate: string;

  private latestCadenceStartDate: string;

  public ngOnInit(): void {
    this.latestCadenceStartDate = this.latestAvailableDate || this.cadenceStartDate;

    this.setCadenceEndDate();
  }

  public canGoToPrev(): boolean {
    return !this.earliestAvailableDate || dayjs(this.earliestAvailableDate).utc().isBefore(dayjs(this.cadenceStartDate).utc());
  }

  public goToPrev(): void {
    const newCadenceStartDate = dayjs(this.cadenceStartDate).utc().subtract(this.cadenceDurationInDays, "day").toISOString();
    this.canGoToPrev() && this.goTo(newCadenceStartDate);
  }

  public canGoToNext(): boolean {
    return !this.latestAvailableDate || dayjs(this.cadenceEndDate).utc().isBefore(dayjs(this.latestAvailableDate).utc());
  }

  public goToNext(): void {
    const newCadenceStartDate = dayjs(this.cadenceStartDate).utc().add(this.cadenceDurationInDays, "day").toISOString();
    this.canGoToNext() && this.goTo(newCadenceStartDate);
  }

  public canGoToLatest(): boolean {
    return this.cadenceStartDate !== this.latestCadenceStartDate;
  }

  public goToLatest(): void {
    this.canGoToLatest() && this.goTo(this.latestCadenceStartDate);
  }

  private goTo(newCadenceStartDate: string): void {
    if (newCadenceStartDate && newCadenceStartDate !== this.cadenceStartDate) {
      this.cadenceStartDate = newCadenceStartDate;
      this.setCadenceEndDate();
      this.onCadenceChange.emit({ cadenceStartDate: newCadenceStartDate, cadenceEndDate: this.cadenceEndDate });
    }
  }

  private setCadenceEndDate(): void {
    this.cadenceEndDate = dayjs(this.cadenceStartDate)
      .utc()
      .add(this.cadenceDurationInDays - 1, "day")
      .toISOString();
  }
}
